import { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { ComparisonSetWithoutOwn } from 'frontend-utils/utils/constants/benchmark-insight';
import type { GeometryCollection, Point, Polygon } from 'geojson';
import type { BeniSmartCompset } from 'lumen/models';
import BeniMarketComposition from 'lumen/models/benchmark-insight/market-composition';

// 1. Define a specific type for your custom circle geometry
// This extends the standard 'Point' geometry with your custom properties.
export interface CirclePointProperties {
  radius: number;
  sub_type: 'Circle';
}

// 2. Create a union type for all possible geometries in your market shape
export type MarketGeometry = Polygon | Point;

// 3. Define the final MarketShape interface
// It's a GeometryCollection that specifically contains your MarketGeometry types.
export interface MarketShape extends GeometryCollection {
  geometries: MarketGeometry[];
  properties?: CirclePointProperties;
}

export default class BeniMarketCompositionMarket extends BeniMarketComposition {
  // @ts-expect-error: Class inheritance
  [Type] = 'benchmark-insight/market-composition-market' as const;

  @belongsTo('benchmark-insight/competitors/smart-compset', {
    async: false,
    inverse: null,
  })
  declare settings?: BeniSmartCompset;

  @attr('string') declare comparisonSetType: ComparisonSetWithoutOwn;
  @attr('number') declare hotelCount: number;
  // @ts-expect-error: No overload matches this call.
  @attr('number', { allowNull: true }) declare marketClassGroupShare:
    | number
    | null;

  @attr() declare marketShape?: MarketShape;
  @attr('number') declare proximityRadius: number;
  @attr('number') declare proximityShare: number;
  // @ts-expect-error: No overload matches this call.
  @attr('number', { allowNull: true }) declare starRatingGroupShare:
    | number
    | null;
}
